import React, { Component } from 'react'
import i18next from "i18next";

class AccessDenied extends Component {
    render() {
        return (
            <div className="error-page-container">
                <img className='error-page-img' src='/img/accessdenied.png' />
                <p className="error-page-text">{i18next.t(10774)}</p>
                <a href="/" className="btn btn-fga-primary mb-3">{i18next.t(10775)}</a>
            </div>
        )
    }
}

export default AccessDenied;
